import localStorageKeys from "@constants/localStorageKeys";

export const storeTourId = (tourId: string): void => {
  localStorage.setItem(localStorageKeys.PRODUCT_FRUITS_TOUR_RUNNING, tourId);
};

export const getStoredTourId = (): string | null => {
  return localStorage.getItem(localStorageKeys.PRODUCT_FRUITS_TOUR_RUNNING);
};

export const removeStoredTourId = (): void => {
  localStorage.removeItem(localStorageKeys.PRODUCT_FRUITS_TOUR_RUNNING);
};
